
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceforitcompanyinpune() {



    const cardData =
    {
        keyword: 'Cab Service for IT Company in Pune  ',
        heading: 'etravo : Cab Service for IT Company in Pune ',



"headingDescription": "eTravo provides reliable Cab Service for IT Companies in Pune, designed to support seamless employee transportation, shift-based commuting, airport transfers, and corporate travel needs. With a fleet of well-maintained, GPS-enabled vehicles and professional chauffeurs, eTravo ensures safe, punctual, and comfortable daily mobility for IT professionals. Flexible monthly contracts and scalable fleet options make it ideal for IT parks and corporate campuses across Pune.",

"top": "Top IT Company Locations for Cab Services in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Pune’s largest IT hub, hosting major tech companies and MNCs, requiring large-scale employee transport and shift-based cab services."
  },
  {
    "title": "Kharadi IT Park",
    "description": "A rapidly growing IT and business district with EON IT Park and World Trade Center, demanding reliable daily employee commute solutions."
  },
  {
    "title": "Magarpatta Cybercity",
    "description": "A self-sustained IT township with multiple corporate offices, ideal for structured corporate cab and shuttle services."
  },
  {
    "title": "Hadapsar IT Zone",
    "description": "Home to SP Infocity and other tech parks, making it a key area for employee pick and drop services."
  },
  {
    "title": "Baner",
    "description": "A developing IT and startup hub with growing corporate offices requiring flexible cab services for employees."
  },
  {
    "title": "Balewadi High Street",
    "description": "A commercial and IT-friendly zone with offices and coworking spaces, ideal for executive and employee transportation."
  },
  {
    "title": "Wakad",
    "description": "A major residential area for IT employees working in Hinjewadi, heavily dependent on daily cab services."
  },
  {
    "title": "Viman Nagar",
    "description": "Close to the airport and IT corridors, serving professionals with reliable corporate transport solutions."
  },
  {
    "title": "Koregaon Park",
    "description": "A premium business locality with corporate offices and consulting firms requiring executive travel services."
  },
  {
    "title": "Pimpri-Chinchwad IT & Industrial Zone",
    "description": "A large industrial and IT region with manufacturing and tech companies needing workforce transportation support."
  }
],


"services": [
{
"name": "IT Company Cab Pune",
"description": "eTravo offers specialized IT company cab services in Pune designed for smooth and reliable transportation for tech firms. Our service ensures timely pickups, comfortable rides, and professional chauffeurs, helping IT companies maintain efficient daily operations."
},
{
"name": "IT Employee Transport Pune",
"description": "Our IT employee transport services in Pune are tailored for safe and punctual workforce commuting. eTravo provides structured pickup and drop solutions, ensuring employees reach offices on time with complete comfort and safety."
},
{
"name": "Software Company Cab Service Pune",
"description": "eTravo provides dependable cab services for software companies in Pune. Designed for developers, engineers, and corporate teams, our service ensures reliable transportation for daily commutes and business travel."
},
{
"name": "Tech Company Taxi Pune",
"description": "Our tech company taxi services in Pune are ideal for startups and established IT firms. eTravo ensures clean vehicles, experienced drivers, and timely service for meetings, office commutes, and client visits."
},
{
"name": "IT Park Cab Service Pune",
"description": "eTravo offers IT park cab services in Pune covering major hubs like Hinjewadi and Kharadi. We provide efficient and reliable transport solutions for employees working in IT parks, ensuring smooth daily commuting."
},
{
"name": "Corporate IT Transport Pune",
"description": "Our corporate IT transport services in Pune are designed to support tech companies with structured mobility solutions. eTravo ensures punctual service, route optimization, and professional travel experiences for employees and executives."
},
{
"name": "Employee Cab IT Pune",
"description": "eTravo provides dedicated employee cab services for IT companies in Pune. Our solutions focus on safe travel, timely pickups, and comfortable rides, ensuring a hassle-free commute for tech professionals."
},
{
"name": "IT Office Pickup Drop Pune",
"description": "Simplify daily commuting with eTravo’s IT office pickup and drop services in Pune. We ensure reliable scheduling, safe transportation, and smooth travel for employees working in IT offices."
},
{
"name": "Company Cab for IT Pune",
"description": "eTravo offers company cab services for IT firms in Pune with customized solutions. From employee transport to executive travel, our services are designed to meet the dynamic needs of tech companies."
},
{
"name": "Business Cab IT Firms Pune",
"description": "Our business cab services for IT firms in Pune provide efficient transportation for meetings, conferences, and daily operations. eTravo ensures professional service, comfort, and punctual travel for tech teams."
},
{
"name": "Tech Staff Transport Pune",
"description": "eTravo provides reliable tech staff transport services in Pune for IT companies. Our service ensures safe and well-coordinated commuting for employees, supporting smooth daily operations."
},
{
"name": "IT Cab Hire Pune",
"description": "Choose eTravo’s IT cab hire services in Pune for flexible and dependable transportation. Ideal for both daily commutes and corporate travel, our service ensures comfort and efficiency for IT professionals."
},
{
"name": "Office Taxi IT Pune",
"description": "Our office taxi services for IT companies in Pune are designed for quick and reliable travel. eTravo ensures timely pickups, comfortable vehicles, and professional drivers for daily office use."
},
{
"name": "Corporate Cab IT Services Pune",
"description": "eTravo offers corporate cab services for IT companies in Pune with a focus on professionalism and efficiency. Our services are ideal for employee transport, executive travel, and client handling."
},
{
"name": "IT Employee Commute Pune",
"description": "eTravo’s IT employee commute services in Pune provide safe and comfortable daily travel solutions. With structured routes and reliable service, we help tech companies ensure smooth workforce mobility."
}
],
"tableData": [
["IT Company Cab Pune", "IT Employee Transport Pune"],
["Software Company Cab Service Pune", "Tech Company Taxi Pune"],
["IT Park Cab Service Pune", "Corporate IT Transport Pune"],
["Employee Cab IT Pune", "IT Office Pickup Drop Pune"],
["Company Cab for IT Pune", "Business Cab IT Firms Pune"],
["Tech Staff Transport Pune", "IT Cab Hire Pune"],
["Office Taxi IT Pune", "Corporate Cab IT Services Pune"],
["IT Employee Commute Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Specialized Cab Service for IT Companies in Pune",
      "WhyChoosedescription": "eTravo provides dedicated cab services for IT companies in Pune, ensuring seamless employee transportation across major IT hubs like Hinjewadi, Kharadi, Magarpatta, and Baner."
    },
    {
      "WhyChooseheading": "Designed for IT Shift-Based Operations",
      "WhyChoosedescription": "Our services are tailored for IT companies with day, night, and rotational shifts, ensuring safe and timely employee transportation at all hours." 
    },
    {
      "WhyChooseheading": "Reliable and On-Time Employee Commute",
      "WhyChoosedescription": "We ensure punctual pickups and drop-offs for IT employees, helping companies maintain productivity and avoid delays in operations." 
    },
    {
      "WhyChooseheading": "Smart Route Planning and Optimization",
      "WhyChoosedescription": "With optimized routes and scheduling, we reduce travel time and improve efficiency for employees commuting from different parts of Pune." 
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Safety Focus",
      "WhyChoosedescription": "Our trained drivers follow strict safety protocols and corporate etiquette, ensuring a secure and comfortable journey for IT professionals." 
    },
    {
      "WhyChooseheading": "Technology-Enabled Fleet Management",
      "WhyChoosedescription": "We provide GPS tracking, real-time updates, and centralized monitoring, giving companies full visibility and control over employee transportation." 
    },
    {
      "WhyChooseheading": "Flexible Monthly and Contract-Based Plans",
      "WhyChoosedescription": "eTravo offers customizable plans including daily pickup-drop and long-term contracts, helping IT companies manage transportation efficiently." 
    },
    {
      "WhyChooseheading": "24/7 Support for IT Corporate Travel",
      "WhyChoosedescription": "Our support team is available round the clock to handle schedule changes, emergency requests, and smooth coordination for IT workforce mobility." 
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is cab service for IT companies in Pune?',
            answer: 'Cab service for IT companies in Pune includes organized employee transportation for daily office commutes, shift-based travel, and corporate mobility solutions.',
        },
        {
            question: 'Why do IT companies need corporate cab services in Pune?',
            answer: 'IT companies require reliable transportation to ensure employees reach offices safely and on time, improving productivity and reducing commute stress. :contentReference[oaicite:0]{index=0}',
        },
        {
            question: 'Do you provide cab services for night shifts in IT companies?',
            answer: 'Yes, eTravo offers safe and reliable cab services for night shifts with proper driver verification and security protocols.',
        },
        {
            question: 'Which IT areas in Pune are covered by your services?',
            answer: 'We cover all major IT hubs including Hinjewadi, Magarpatta, Kharadi, EON IT Park, and other business zones. :contentReference[oaicite:1]{index=1}',
        },
        {
            question: 'Can IT companies customize employee transport routes?',
            answer: 'Yes, routes and schedules can be customized based on employee locations and company requirements.',
        },
        {
            question: 'Do you provide GPS tracking for IT employee transport?',
            answer: 'Yes, all vehicles are GPS-enabled, allowing real-time tracking and improved safety monitoring. :contentReference[oaicite:2]{index=2}',
        },
        {
            question: 'Are your cab services suitable for large IT teams?',
            answer: 'Yes, we provide scalable solutions including multiple vehicles and route planning for large employee groups.',
        },
        {
            question: 'Is the service available 24/7 for IT companies?',
            answer: 'Yes, our services operate round the clock to support all IT shift timings and business requirements.',
        },
        {
            question: 'Do you provide GST billing for IT corporate travel?',
            answer: 'Yes, we provide proper GST-compliant invoices for all corporate bookings.',
        },
        {
            question: 'How can an IT company book cab services in Pune?',
            answer: 'Companies can book through our website or contact our corporate support team for customized transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Kunal Verma',
        designation: 'IT Operations Manager, TechNova Solutions, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s cab service for our IT company in Pune has been exceptional. Their punctual service and well-managed routes have improved our team’s daily commute.”',
    },
    {
        name: 'Ms. Sneha Iyer',
        designation: 'HR Manager, CloudMatrix Technologies, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for employee transportation across shifts. Their safety measures and real-time tracking make them the perfect partner for IT companies.”',
    },
];











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service for IT Company in Pune",
  "image": "https://www.etravo.in/images/keyword/it-company-cab-pune.jpg",
  "description": "Specialized cab services for IT companies in Pune by eTravo. Ideal for IT employee transport, office pickup and drop, tech park commute, and corporate travel with reliable and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-for-it-company-in-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab Service for IT Company in Pune | IT Employee Transport Solutions | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service for IT companies in Pune with eTravo for employee transport, office pickup and drop, tech park commute, and corporate IT travel needs. Safe and reliable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/126.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceforitcompanyinpune;